// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import ProtectedRoute from "./components/ProtectedRoute";
// import Login from "./components/Login";
// import Layout from "./components/Layout";
// import MeineAuftrage from "./components/MeineAuftrage";
// import Partner from "./components/Partner";
// import AddNeuenAuftrag from "./components/AddNeuenAuftrag";
// import AddPartner from "./components/AddPartner";
// import OpenEye from "./components/OpenEye";
// import PartnerEye from "./components/PartnerEye";
// import PartnerEdite from "./components/PartnerEdite"
// // import SignaturePad from "./components/SignaturePad";
// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Layout/>}>
//         <Route index
//         element={
//           <ProtectedRoute>
//             <MeineAuftrage />
//           </ProtectedRoute>
//         }/>
//         <Route path="AddNeuenAuftrag"
//         element={
//           <ProtectedRoute>
//             <AddNeuenAuftrag />
//           </ProtectedRoute>
//         }/>

//         <Route path="aftrageEye/:id"
//         element={
//           <ProtectedRoute>
//             <OpenEye />
//           </ProtectedRoute>
//         }/>
//         <Route path="/partner"
//         element={
//           <ProtectedRoute>
//             <Partner />
//           </ProtectedRoute>
//         }/>
//         <Route path="/partnerEye/:id"
//         element={
//           <ProtectedRoute>
//             <PartnerEye />
//           </ProtectedRoute>
//         }/>
//          <Route path="/partnerEdite/:id"
//         element={
//           <ProtectedRoute>
//             <PartnerEdite />
//           </ProtectedRoute>
//         }/>
//         <Route path="/AddPartner"
//         element={
//           <ProtectedRoute>
//             <AddPartner />
//           </ProtectedRoute>
//         }/>
//         </Route>
//         <Route path="/login" element={<Login />} />
//       </Routes>
//     </Router >
//   );
// }

// export default App;





import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import Layout from "./components/Layout";
import MeineAuftrage from "./components/MeineAuftrage";
import Partner from "./components/Partner";
import AddNeuenAuftrag from "./components/AddNeuenAuftrag";
import AddPartner from "./components/AddPartner";
import OpenEye from "./components/OpenEye";
import PartnerEye from "./components/PartnerEye";
import PartnerEdite from "./components/PartnerEdite";
import Admin from "./components/Admin";
import AddAdmin from "./components/AddAdmin";
// import SignaturePad from "./components/SignaturePad";

function App() {
  return (
    <Router>
      <Routes>
        {/* Layout Wrapper */}
        <Route path="/" element={<Layout />}>
          {/* Default Route */}
          <Route
            index
            element={
              <ProtectedRoute>
                <MeineAuftrage />
              </ProtectedRoute>
            }
          />
          {/* Other Routes */}
          <Route
            path="AddNeuenAuftrag"
            element={
              <ProtectedRoute>
                <AddNeuenAuftrag />
              </ProtectedRoute>
            }
          />
          <Route
            path="aftrageEye/:id"
            element={
              <ProtectedRoute>
                <OpenEye />
              </ProtectedRoute>
            }
          />
          <Route
            path="partner"
            element={
              <ProtectedRoute>
                <Partner />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="addAdmin"
            element={
              <ProtectedRoute>
                <AddAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="partnerEye/:id"
            element={
              <ProtectedRoute>
                <PartnerEye />
              </ProtectedRoute>
            }
          />
          <Route
            path="partnerEdite/:id"
            element={
              <ProtectedRoute>
                <PartnerEdite />
              </ProtectedRoute>
            }
          />
          <Route
            path="AddPartner"
            element={
              <ProtectedRoute>
                <AddPartner />
              </ProtectedRoute>
            }
          />
        </Route>
        {/* Login Route */}
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
